export default "__VITE_ASSET__26fb22de__"